import { auth, isFirebaseEnabled } from '../services/firebase';
import { signOut } from 'firebase/auth';

const STORAGE_KEY = 'paycircle_session_expiry';
const SESSION_TIMEOUT_MS = 604800 * 1000; // 7 days in milliseconds

/**
 * Updates the last active timestamp in localStorage if the user is authenticated.
 */
export const updateLastActive = (): void => {
  if (typeof window !== 'undefined') {
    try {
      const sessionUser = localStorage.getItem('paycircle_session_user');
      if (sessionUser) {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      }
    } catch (e) {
      console.error('[Auth] Failed to update last active timestamp:', e);
    }
  }
};

/**
 * Checks the last active timestamp and ensures the active timestamp is populated.
 * Session persistence keeps users logged in indefinitely until explicit logout.
 */
export const checkSessionInactivity = async (): Promise<void> => {
  if (typeof window === 'undefined') return;

  try {
    const sessionUser = localStorage.getItem('paycircle_session_user');
    if (!sessionUser) {
      return; // No active session to check
    }

    // Initialize/refresh the last active timestamp so telemetry remains accurate
    if (!localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, Date.now().toString());
    }
  } catch (e) {
    console.error('[Auth] Error during session inactivity check:', e);
  }
};

// Global interceptor for fetch API calls to automatically track user actions
if (typeof window !== 'undefined') {
  try {
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      updateLastActive();
      return originalFetch.apply(this, args);
    };
    console.log('[Auth] Global fetch interceptor registered for activity tracking.');
  } catch (e) {
    console.error('[Auth] Failed to register global fetch interceptor:', e);
  }
}
